export const DEBUG_LAST_ACTION_KEY = "myv_last_action_label";
export const DEBUG_LAST_ACTION_AT_KEY = "myv_last_action_at";

const SELECTION_KEYS = {
  client: "myv_selected_client_updated_at",
  property: "myv_selected_property_updated_at",
  analysis: "myv_selected_analysis_updated_at",
};

export const setDebugLastAction = (label) => {
  if (!label) return;
  try {
    localStorage.setItem(DEBUG_LAST_ACTION_KEY, label);
    localStorage.setItem(DEBUG_LAST_ACTION_AT_KEY, new Date().toISOString());
    if (typeof window !== "undefined") {
      window.dispatchEvent(new Event("myv_debug_state_updated"));
    }
  } catch (error) {
    // no-op
  }
};

export const markSelectionUpdated = (type) => {
  const key = SELECTION_KEYS[type];
  if (!key) return;
  try {
    localStorage.setItem(key, new Date().toISOString());
    if (typeof window !== "undefined") {
      window.dispatchEvent(new Event("myv_debug_state_updated"));
    }
  } catch (error) {
    // no-op
  }
};

export const readSelectionTimestamp = (type) => {
  const key = SELECTION_KEYS[type];
  if (!key) return "";
  try {
    return localStorage.getItem(key) || "";
  } catch (error) {
    return "";
  }
};
